import { ApplicationState } from 'app/store/store'

import { AppInitState } from '../app.types'

export const getAppInitState = (state: ApplicationState): AppInitState =>
  state.app.initState
